<script lang="ts">
  import { _ } from 'svelte-i18n';

  export let profile_photo: string;
  export let first_name: string;
  export let last_name: string;
  export let username: string;
  export let shape: string = "";
  export let is_spinning = false;
  export let pad_right: boolean; //true if the avatar is beside a name, so we want a bit of space
  var img_class = is_spinning ? "avatar fa-spin" : "avatar";
  var img_style = (username != null ? "" : "visibility: hidden;") + (shape == "circle" ? " border-radius: 100% !important;" : "") + (pad_right ? "margin-right: 8px;" : "");
  var error = false;
  function avatar(url: string): string {
    if (url == null || url.length == 0) {
      return "/assets/admin/layout/img/avatar.png";
    }
    return url;
  }
  $: url = error ? avatar(null) : avatar(profile_photo);
</script>

<img class={img_class}
  style={img_style}
  src={url}
  on:error={()=>error=true}
  title="{first_name} {last_name}"
  alt={$_("sessions.alt.user_avatar", {values: {name: username}})}
/>

<style lang="scss">
.avatar {
  display: inline-block;
  object-fit: cover; /*  Crop image to fill element. */
  height: var(--avatar-height, 2em);
  width: var(--avatar-height, 2em);
  margin: var(--avatar-margin, 0);
  border-radius: 4px;
}
</style>
